import { Component, Input } from '@angular/core';
import { BehavioralFactorNoE } from '../../core-data-model/BehavioralFactor.model';

@Component({
    selector: 'svg-letter',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-18 -18 36 36">
            <g>
                <circle
                    cx="0"
                    cy="0"
                    r="16.91"
                    style="fill:#fff;stroke:#010101;stroke-miterlimit: 10;stroke-width:1.37813433510092px"
                ></circle>
                <ng-container>
                    @switch (letter) {
                        @case ('A') {
                            <path
                                d="M1.65,-8.99l5.69,15.21h-3.47L2.72,2.8h-5.69l-1.19,3.39h-3.37l5.75-15.21Zm.19,9.33L-0.07,-5.2h0l-2,5.58Z"
                                style="fill:#0092c8"
                            ></path>
                        }
                        @case ('B') {
                            <path
                                d="M1.13,-7.32a9.46,9.46,0,0,1,2,.19,4.28,4.28,0,0,1,1.54.63,2.93,2.93,0,0,1,1,1.16,4.08,4.08,0,0,1,.35,1.79,3.33,3.33,0,0,1-.52,1.92A3.78,3.78,0,0,1,3.92,0.32a3.66,3.66,0,0,1,2.1,1.42,4.65,4.65,0,0,1,.25,4.43,3.88,3.88,0,0,1-1.2,1.37,5.31,5.31,0,0,1-1.73.79,7.76,7.76,0,0,1-2,.26h-7.37V-7.32Zm-.43,6.16a2.41,2.41,0,0,0,1.47-.43,1.61,1.61,0,0,0,.57-1.39,1.77,1.77,0,0,0-.19-.87,1.43,1.43,0,0,0-.51-.53,2.2,2.2,0,0,0-.74-.27,5,5,0,0,0-.86-.07h-3.13v3.56Zm.19,6.46a4.46,4.46,0,0,0,.94-.1,2.29,2.29,0,0,0,.79-.32,1.61,1.61,0,0,0,.54-.61,2.1,2.1,0,0,0,.2-1,2,2,0,0,0-.66-1.67,2.82,2.82,0,0,0-1.75-.5h-3.64v4.18Z"
                                style="fill:#0092c8"
                            ></path>
                        }
                        @case ('C') {
                            <path
                                d="M3.33,-3.68a3.36,3.36,0,0,0-.75-.84,3.49,3.49,0,0,0-2.2-.77,3.9,3.9,0,0,0-1.92.44,3.62,3.62,0,0,0-1.28,1.17,5.1,5.1,0,0,0-.71,1.67,8.33,8.33,0,0,0-.22,1.94,7.75,7.75,0,0,0,.22,1.86,5,5,0,0,0,.71,1.63,3.65,3.65,0,0,0,1.28,1.16,3.9,3.9,0,0,0,1.92.44,3.09,3.09,0,0,0,2.4-.94,4.34,4.34,0,0,0,1.06-2.47h3.24a7.74,7.74,0,0,1-.66,2.58,6.19,6.19,0,0,1-1.41,2,6,6,0,0,1-2,1.24,7.5,7.5,0,0,1-2.58.43,7.8,7.8,0,0,1-3.14-.61,6.72,6.72,0,0,1-2.35-1.67,7.38,7.38,0,0,1-1.47-2.5,9.17,9.17,0,0,1-.51-3.1,9.48,9.48,0,0,1,.51-3.16,7.59,7.59,0,0,1,1.47-2.55,6.71,6.71,0,0,1,2.35-1.7,8.16,8.16,0,0,1,5.52-.26,6.44,6.44,0,0,1,2,1.06,5.69,5.69,0,0,1,1.46,1.72,6.13,6.13,0,0,1,.73,2.34H3.72A2.74,2.74,0,0,0,3.33,-3.68Z"
                                style="fill:#0092c8"
                            ></path>
                        }
                        @case ('D') {
                            <path
                                d="M1.07,-7.24a7.84,7.84,0,0,1,2.74.47,6,6,0,0,1,2.19,1.41,6.52,6.52,0,0,1,1.45,2.34,9.49,9.49,0,0,1,.52,3.3,10.53,10.53,0,0,1-.43,3.07,6.77,6.77,0,0,1-1.29,2.43,6,6,0,0,1-2.15,1.61,7.28,7.28,0,0,1-3,.59h-6.56V-7.24Zm-.23,12.4a4.29,4.29,0,0,0,1.41-.23,3.09,3.09,0,0,0,1.21-.78,3.89,3.89,0,0,0,.85-1.42,6.21,6.21,0,0,0,.32-2.13,8.88,8.88,0,0,0-.22-2.08,4.15,4.15,0,0,0-.73-1.59,3.27,3.27,0,0,0-1.35-1,5.4,5.4,0,0,0-2.08-.35h-2.39V5.12Z"
                                style="fill:#0092c8"
                            ></path>
                        }
                    }
                </ng-container>
            </g>
        </svg>
    `,
    standalone: false
})
export class LetterComponent {
    @Input() letter: BehavioralFactorNoE;
}
